export enum OtpTypes {
  MEMBERSHIP_CONFIRMATION_MESSAGE = 'MembershipConfirmationMessage',
  MEMBERSHIP_CANCELLATION_MESSAGE = 'MembershipCancellationMessage',
  PAYMENT_MESSAGE = 'PaymentMessage',
  PROFILE_UPDATE_MESSAGE = 'ProfileUpdateMessage',
  JOIN_CLUBS_MESSAGE = 'JoinClubsMessage',
}
